window.onload = (event) => {
    const selectElement = document.querySelector("#request-type");
    const messageElement = document.querySelector(".request-type-message");

    selectElement.addEventListener("change", (event) => {
        let option = event.target.value;
        if (option == 'Order Issue/Return'){
            messageElement.style.display = 'block';
        }
        else{
            messageElement.style.display = 'none';
        }
    });
  };

